import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {EnvironmentService} from "@vision-inspection/environment";

@Injectable({
  providedIn: 'root'
})
export class AuthProxy {
  private httpClient: HttpClient = inject(HttpClient);
  private environmentService: EnvironmentService = inject(EnvironmentService);

  public isAuthenticated(): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.getBaseUrl()}/isLoggedIn`);
  }

  private getBaseUrl(): string {
    return `${this.environmentService.getApiBaseUrl()}api/auth`;
  }
}
